export const PARTNER_LOGO_SIZE = 50;
